<template lang="html">
  <div class="column is-6" id="mai" ref="mai" data-aos="fade-up" data-aos-anchor-placement="top-center">
    <div class="overlay-image">
      <figure class="image is-4by3">
        <router-link to="/mai">
            <img class="image" src="static/images/mai/Mai pääkuva.jpg">
            <div class="hover">
              <div class="text">
                <p class="title">{{ mai.portfolioTitle }}</p>
                <p class="subtitle">{{ mai.portfolioDescription }}</p>
              </div>
            </div>
        </router-link>
      </figure>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      mai: {
        portfolioTitle: 'Mai',
        portfolioDescription: '2013 – Vietnam'
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/Mai.vue